import {GetPrescriptionsListParams} from 'domain/usecases/private/my-hospitalization/get-prescriptions-list';
import {makeGetPrescriptionsList} from 'main/factories/usecases/private/my-hospitalization/get-prescriptions-list-factory';
import {PRESCRIPTIONS_LIST_MOCK} from './mock';

export const getPrescriptionsList = async (params: GetPrescriptionsListParams) => {
	try {
		const response = await makeGetPrescriptionsList().get(params);

		if (typeof response === 'string') {
			return {
				pages: 0,
				items: [],
			};
		}

		const pages = Math.ceil(response.totalElements / params.size);

		return {
			pages,
			items: response.content,
		};
	} catch (error) {
		throw new Error();
	}
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getPrescriptionsListMock = async (params: GetPrescriptionsListParams) => ({
	pages: 1,
	items: PRESCRIPTIONS_LIST_MOCK,
});
